<div class="root" *ngIf="show" @fadeOut>
    <div class="root__logo">
    </div>
    <div class="root__bottom-logo">
    </div>
</div>
